import faker from 'faker';

import { IWorkflowState, IWorkflowStateData } from '../workflow.types';
import { WorkflowState } from '../workflow';
import { createRange } from '@/utils/helpers';

export function createRandomWorkflowState(): IWorkflowStateData {
  return {
    id: faker.datatype.number(),
    name: faker.random.word(),
    default: faker.datatype.boolean(),
    groups: []
  };
}

export const mockWorkflowStatesData: IWorkflowStateData[] = createRange(
  6
).map(() => createRandomWorkflowState());

export const mockWorkflowStates = (
  data: IWorkflowStateData[] = mockWorkflowStatesData
): IWorkflowState[] => data.map(item => new WorkflowState(item));
